module.exports = __webpack_public_path__ + "assets/img/favicons/favicon-16x16.png";